import en from "./translations/en.json";

type TranslationValue =
  | string
  | {
      one: string;
      other: string;
    };

function makeTranslationObject<T extends Record<string, TranslationValue>>(
  keys: T
) {
  return Object.fromEntries(Object.keys(keys).map((key) => [key, key])) as {
    [key in keyof T]: key;
  };
}

export const Translations = {
  ...makeTranslationObject(en),
} as const;
